export class IMemberFeeDetails {
    _id: string;
    invoice: string;
    fee: number;
    pay: number;
    remainingBalance: number;
    /** Remaining package balance after this fee (partial payment); from customerFees.balance */
    balance?: number | string;
    tax: number;
    status: string;
    date: Date;
    createdDate: Date;
    month: number;
    day: string;
    year: number;
    memberId: string;
    description: string;
    dueDate: Date;
    nextDueDate: Date;
    /** Snapshot of member due date before this payment (legacy period start fallback). */
    previousDueDate?: string | Date;
    feeReceiptImageUrl: string;
    transactionNumber: string;
    paymentMode: string;
    isDelete: boolean;
    isDefaulter: boolean;
    isSynced: boolean;
    type: string;
    scope: string;
    currentUserData: any;
    initiatedFrom: any;
    oldDate: any;
    discountAmount:number;
    discount:number;
    createdBy: string;
    enteredBy: string;
    remainingSessionCount: number;
    sessionCount: string;
    dayPass : String;
    trainerName: string;
    taxRate: number;
    taxCalculationType: string;
    noOfMonths : number;
    name : string;
    tagNumber: any;
    packageName: string;
    packageId?: string;
    isSecondaryPackageFee?: boolean;
    dueDateAfterApproval: Date;
    isApproved: boolean;
    months: Array<any> = [];
    years: Array<any> = [];
    numberOfVisitors: number;
    SRBInvoiceID: string
    /** Split reprint: one entry per payment mode ("Mode: SRB-id"). */
    SRBInvoiceLines?: string[];
    FBRInvoiceID?: string;
    FBRInvoiceIDs?: string[];
    /** Split reprint: one raw FBR invoice number per payment row. */
    FBRInvoiceLines?: string[];
    walletAmountPaid: boolean;
    totalFeePaid: number;
    /** Period-based billing: pay next period in advance */
    payAdvance?: boolean;
    /** Add Fee only: start a new period after a lapsed partial. */
    payNewPeriod?: boolean;
    /** Set when posting monthly fee for every member in a sameHistory group batch. */
    sameHistoryGroupPayment?: boolean;
    /** Amount deducted from wallet at save (monthly fee only) */
    walletAmountUsed?: number;
    /** Period-based billing range (monthly and trainer fee rows) */
    billingPeriodStart?: string | Date;
    billingPeriodEnd?: string | Date;
    /** Pre-tax fee for this billing period (full month or shortened). */
    billingPackageFee?: number;
    billingPeriodDays?: number;
    gymSharePercentage: number;
    trainerSharePercentage: number;
    trainerShare: string;
    gymShare: string;
    isSplitPayment?: boolean;
    splitGroupId?: string;
    splitIndex?: number;
    splitTotal?: string | number;
}
